import { render, staticRenderFns } from "./ViewTransactions.vue?vue&type=template&id=6244582a&scoped=true"
import script from "./ViewTransactions.vue?vue&type=script&lang=js"
export * from "./ViewTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6244582a",
  null
  
)

export default component.exports